const STATUS_FIELDS = [
  { key: 'device.model.family', label: 'Gerätefamilie', values: ['iPhone', 'iPad', 'Mac', 'AppleTV'] },
  { key: 'device.operating-system.family', label: 'Betriebssystem', values: ['iOS', 'macOS', 'tvOS', 'visionOS'] },
  { key: 'device.operating-system.version', label: 'OS-Version' },
  { key: 'device.model.identifier', label: 'Modellkennung' },
];

const OPERATORS = [
  { id: '==', label: 'ist' },
  { id: '!=', label: 'ist nicht' },
  { id: '>=', label: 'mindestens' },
  { id: 'IN', label: 'ist einer von' },
];

function quote(value) {
  const raw = String(value || '').trim();
  if (!raw) return "''";
  if (raw.includes(',') && !raw.startsWith('{')) {
    const parts = raw.split(',').map((item) => `'${item.trim().replace(/'/g, "\\'")}'`);
    return `{ ${parts.join(', ')} }`;
  }
  if (/^[\d.]+$/.test(raw)) return raw;
  return `'${raw.replace(/'/g, "\\'")}'`;
}

function parseRules(predicate) {
  const text = String(predicate || '').trim();
  if (!text) return [];
  const parts = text.split(/\s+AND\s+/i);
  return parts.map((part) => {
    const match = part.match(/@status\(([^)]+)\)\s*(==|!=|>=|IN)\s*(.+)$/i);
    if (!match) return null;
    return { key: match[1].trim(), op: match[2].toUpperCase() === 'IN' ? 'IN' : match[2], value: match[3].trim().replace(/^'|'$/g, '').replace(/[{}]/g, '').replace(/'/g, '').trim() };
  }).filter(Boolean);
}

function buildPredicate(rules) {
  const clauses = (rules || [])
    .filter((rule) => rule.key && String(rule.value || '').trim())
    .map((rule) => {
      const op = rule.op === 'IN' || String(rule.value).includes(',') ? 'IN' : (rule.op || '==');
      return `@status(${rule.key}) ${op} ${quote(rule.value)}`;
    });
  return clauses.join(' AND ');
}

export default function DdmPredicateEditor({ value, onChange }) {
  const rules = parseRules(value);
  const hasCustom = Boolean(value) && rules.length === 0;

  const setRules = (next) => onChange(buildPredicate(next) || undefined);

  return (
    <div>
      <div className="d-flex flex-wrap gap-2 mb-2">
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => onChange(undefined)}>
          Immer aktiv
        </button>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={() => onChange("@status(device.model.family) == 'iPad'")}
        >
          Nur iPad
        </button>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={() => onChange("@status(device.model.family) == 'iPhone'")}
        >
          Nur iPhone
        </button>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={() => onChange("@status(device.operating-system.family) == 'tvOS'")}
        >
          Nur Apple TV
        </button>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={() => onChange("@status(device.operating-system.family) == 'macOS'")}
        >
          Nur Mac
        </button>
      </div>
      {(hasCustom ? [] : rules).map((rule, index) => (
        <div key={`${rule.key}-${index}`} className="d-flex flex-wrap gap-2 mb-2">
          <select
            className="form-select form-select-sm"
            style={{ maxWidth: 220 }}
            value={rule.key}
            onChange={(e) => {
              const next = [...rules];
              next[index] = { ...rule, key: e.target.value, value: '' };
              setRules(next);
            }}
          >
            {STATUS_FIELDS.map((field) => (
              <option key={field.key} value={field.key}>{field.label}</option>
            ))}
          </select>
          <select
            className="form-select form-select-sm"
            style={{ maxWidth: 140 }}
            value={rule.op}
            onChange={(e) => {
              const next = [...rules];
              next[index] = { ...rule, op: e.target.value };
              setRules(next);
            }}
          >
            {OPERATORS.map((op) => (
              <option key={op.id} value={op.id}>{op.label}</option>
            ))}
          </select>
          {STATUS_FIELDS.find((field) => field.key === rule.key)?.values ? (
            <select
              className="form-select form-select-sm"
              style={{ maxWidth: 180 }}
              value={rule.value}
              onChange={(e) => {
                const next = [...rules];
                next[index] = { ...rule, value: e.target.value };
                setRules(next);
              }}
            >
              <option value="">Wert…</option>
              {STATUS_FIELDS.find((field) => field.key === rule.key).values.map((item) => (
                <option key={item} value={item}>{item}</option>
              ))}
            </select>
          ) : (
            <input
              className="form-control form-control-sm"
              style={{ maxWidth: 180 }}
              value={rule.value}
              placeholder="Wert"
              onChange={(e) => {
                const next = [...rules];
                next[index] = { ...rule, value: e.target.value };
                setRules(next);
              }}
            />
          )}
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            onClick={() => setRules(rules.filter((_, i) => i !== index))}
          >
            Entfernen
          </button>
        </div>
      ))}
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary mb-2"
        onClick={() => setRules([...rules, { key: 'device.model.family', op: '==', value: 'iPad' }])}
      >
        Bedingung hinzufügen
      </button>
      <label className="form-label small mt-2">Predicate (Apple-Format)</label>
      <input
        className="form-control form-control-sm font-monospace"
        value={value || ''}
        placeholder="leer = immer aktiv"
        onChange={(e) => onChange(e.target.value || undefined)}
      />
      <div className="form-text">
        Beispiel: <code>@status(device.model.family) == &apos;iPad&apos;</code>.
        Die Aktivierung gilt nur, wenn der Ausdruck wahr ist.
      </div>
    </div>
  );
}
